import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import Discover from "./pages/Discover";
import Collection from "./pages/Collection";
import Profile from "./pages/Profile";
import PlayerPage from "./pages/PlayerPage";
import DetailPage from "./pages/DetailPage";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import CreatorSignUp from "./pages/CreatorSignUp"; 
import Navigation from "./components/Navigation";
import globalStyles from "./styles/globalStyles";
import CreatorDashboard from "./pages/CreatorDashboard";
// Layout component to conditionally render navigation
const Layout = ({ children }) => {
  const location = useLocation();

  // Hide navigation on player page, auth pages, and creator signup
  const hideNavigation = ["/player", "/signin", "/signup", "/creator-signup", "/creator-dashboard",].includes(
    location.pathname
  );

  return (
    <>
      {children}
      {!hideNavigation && <Navigation />}
    </>
  );
};

function App() {
  return (
    <>
      <style>{globalStyles}</style>
      <Router>
        <AuthProvider>
          <div className="app-container">
            <Layout>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/discover" element={<Discover />} />
                <Route path="/detail" element={<DetailPage />} />
                <Route path="/player" element={<PlayerPage />} />
                <Route
  path="/creator-dashboard"
  element={
    <ProtectedRoute>
      <CreatorDashboard />
    </ProtectedRoute>
  }
/>
                {/* Auth Routes */}
                <Route path="/signin" element={<SignIn />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/creator-signup" element={<CreatorSignUp />} /> {/* ✅ NEW */}

                {/* Protected Routes (require authentication) */}
                <Route
                  path="/collection"
                  element={
                    <ProtectedRoute>
                      <Collection />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          </div>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;